module.exports = __webpack_public_path__ + "static/media/1.dfc2d81b.png";